// Data KRS (Kartu Rencana Studi) dan KHS (Kartu Hasil Studi)

// KRS Mahasiswa - Andi Pratama (20201001) Semester 7
export const dataKRS = [
    // Andi Pratama - Semester 7
    {
        krs_id: 1,
        nim: "20201001",
        nama_mhs: "Andi Pratama",
        tahun_akademik: "2024/2025",
        semester: "Ganjil",
        semester_ke: 7,
        jadwal_id: 1,
        mk_id: 33,
        kode_mk: "TI701",
        nama_mk: "Metodologi Penelitian",
        sks: 2,
        kelas: "A",
        dosen: "Dr. Citra Dewi, S.Kom., M.Cs.",
        status: "Disetujui"
    },
    {
        krs_id: 2,
        nim: "20201001",
        nama_mhs: "Andi Pratama",
        tahun_akademik: "2024/2025",
        semester: "Ganjil",
        semester_ke: 7,
        jadwal_id: 2,
        mk_id: 34,
        kode_mk: "TI702",
        nama_mk: "Deep Learning",
        sks: 3,
        kelas: "A",
        dosen: "Dr. Citra Dewi, S.Kom., M.Cs.",
        status: "Disetujui"
    },
    {
        krs_id: 3,
        nim: "20201001",
        nama_mhs: "Andi Pratama",
        tahun_akademik: "2024/2025",
        semester: "Ganjil",
        semester_ke: 7,
        jadwal_id: 3,
        mk_id: 35,
        kode_mk: "TI703",
        nama_mk: "Blockchain",
        sks: 3,
        kelas: "A",
        dosen: "Joko Santoso, S.Kom., M.T.",
        status: "Disetujui"
    },
    {
        krs_id: 4,
        nim: "20201001",
        nama_mhs: "Andi Pratama",
        tahun_akademik: "2024/2025",
        semester: "Ganjil",
        semester_ke: 7,
        jadwal_id: 4,
        mk_id: 36,
        kode_mk: "TI704",
        nama_mk: "Cyber Security",
        sks: 3,
        kelas: "A",
        dosen: "Joko Santoso, S.Kom., M.T.",
        status: "Disetujui"
    },
    // Bella Safitri - Semester 7
    {
        krs_id: 5,
        nim: "20201002",
        nama_mhs: "Bella Safitri",
        tahun_akademik: "2024/2025",
        semester: "Ganjil",
        semester_ke: 7,
        jadwal_id: 1,
        mk_id: 33,
        kode_mk: "TI701",
        nama_mk: "Metodologi Penelitian",
        sks: 2,
        kelas: "A",
        dosen: "Dr. Citra Dewi, S.Kom., M.Cs.",
        status: "Disetujui"
    },
    {
        krs_id: 6,
        nim: "20201002",
        nama_mhs: "Bella Safitri",
        tahun_akademik: "2024/2025",
        semester: "Ganjil",
        semester_ke: 7,
        jadwal_id: 2,
        mk_id: 34,
        kode_mk: "TI702",
        nama_mk: "Deep Learning",
        sks: 3,
        kelas: "A",
        dosen: "Dr. Citra Dewi, S.Kom., M.Cs.",
        status: "Disetujui"
    }
];

// KHS (Nilai) - History semester sebelumnya
export const dataKHS = [
    // Andi Pratama - Semester 1
    { khs_id: 1, nim: "20201001", tahun_akademik: "2020/2021", semester: "Ganjil", semester_ke: 1, kode_mk: "TI101", nama_mk: "Algoritma dan Pemrograman", sks: 3, nilai: 85, grade: "A", bobot: 4.00 },
    { khs_id: 2, nim: "20201001", tahun_akademik: "2020/2021", semester: "Ganjil", semester_ke: 1, kode_mk: "TI102", nama_mk: "Matematika Diskrit", sks: 3, nilai: 78, grade: "A-", bobot: 3.75 },
    { khs_id: 3, nim: "20201001", tahun_akademik: "2020/2021", semester: "Ganjil", semester_ke: 1, kode_mk: "TI103", nama_mk: "Pengantar Teknologi Informasi", sks: 2, nilai: 82, grade: "A", bobot: 4.00 },
    { khs_id: 4, nim: "20201001", tahun_akademik: "2020/2021", semester: "Ganjil", semester_ke: 1, kode_mk: "UN101", nama_mk: "Bahasa Indonesia", sks: 2, nilai: 80, grade: "A", bobot: 4.00 },
    { khs_id: 5, nim: "20201001", tahun_akademik: "2020/2021", semester: "Ganjil", semester_ke: 1, kode_mk: "UN102", nama_mk: "Pendidikan Agama", sks: 2, nilai: 88, grade: "A", bobot: 4.00 },
    { khs_id: 6, nim: "20201001", tahun_akademik: "2020/2021", semester: "Ganjil", semester_ke: 1, kode_mk: "UN103", nama_mk: "Bahasa Inggris 1", sks: 2, nilai: 75, grade: "A-", bobot: 3.75 },

    // Andi Pratama - Semester 2
    { khs_id: 7, nim: "20201001", tahun_akademik: "2020/2021", semester: "Genap", semester_ke: 2, kode_mk: "TI201", nama_mk: "Struktur Data", sks: 3, nilai: 82, grade: "A", bobot: 4.00 },
    { khs_id: 8, nim: "20201001", tahun_akademik: "2020/2021", semester: "Genap", semester_ke: 2, kode_mk: "TI202", nama_mk: "Basis Data", sks: 3, nilai: 88, grade: "A", bobot: 4.00 },
    { khs_id: 9, nim: "20201001", tahun_akademik: "2020/2021", semester: "Genap", semester_ke: 2, kode_mk: "TI203", nama_mk: "Sistem Operasi", sks: 3, nilai: 72, grade: "B+", bobot: 3.50 },
    { khs_id: 10, nim: "20201001", tahun_akademik: "2020/2021", semester: "Genap", semester_ke: 2, kode_mk: "TI204", nama_mk: "Kalkulus", sks: 3, nilai: 68, grade: "B", bobot: 3.00 },
    { khs_id: 11, nim: "20201001", tahun_akademik: "2020/2021", semester: "Genap", semester_ke: 2, kode_mk: "UN201", nama_mk: "Bahasa Inggris 2", sks: 2, nilai: 78, grade: "A-", bobot: 3.75 },
    { khs_id: 12, nim: "20201001", tahun_akademik: "2020/2021", semester: "Genap", semester_ke: 2, kode_mk: "UN202", nama_mk: "Pendidikan Pancasila", sks: 2, nilai: 85, grade: "A", bobot: 4.00 },

    // Andi Pratama - Semester 3
    { khs_id: 13, nim: "20201001", tahun_akademik: "2021/2022", semester: "Ganjil", semester_ke: 3, kode_mk: "TI301", nama_mk: "Pemrograman Berorientasi Objek", sks: 3, nilai: 80, grade: "A", bobot: 4.00 },
    { khs_id: 14, nim: "20201001", tahun_akademik: "2021/2022", semester: "Ganjil", semester_ke: 3, kode_mk: "TI302", nama_mk: "Jaringan Komputer", sks: 3, nilai: 76, grade: "A-", bobot: 3.75 },
    { khs_id: 15, nim: "20201001", tahun_akademik: "2021/2022", semester: "Ganjil", semester_ke: 3, kode_mk: "TI303", nama_mk: "Analisis dan Perancangan Sistem", sks: 3, nilai: 82, grade: "A", bobot: 4.00 },
    { khs_id: 16, nim: "20201001", tahun_akademik: "2021/2022", semester: "Ganjil", semester_ke: 3, kode_mk: "TI304", nama_mk: "Statistika", sks: 3, nilai: 70, grade: "B+", bobot: 3.50 },
    { khs_id: 17, nim: "20201001", tahun_akademik: "2021/2022", semester: "Ganjil", semester_ke: 3, kode_mk: "TI305", nama_mk: "Interaksi Manusia dan Komputer", sks: 2, nilai: 85, grade: "A", bobot: 4.00 },

    // Andi Pratama - Semester 4
    { khs_id: 18, nim: "20201001", tahun_akademik: "2021/2022", semester: "Genap", semester_ke: 4, kode_mk: "TI401", nama_mk: "Pemrograman Web", sks: 3, nilai: 90, grade: "A", bobot: 4.00 },
    { khs_id: 19, nim: "20201001", tahun_akademik: "2021/2022", semester: "Genap", semester_ke: 4, kode_mk: "TI402", nama_mk: "Pemrograman Mobile", sks: 3, nilai: 88, grade: "A", bobot: 4.00 },
    { khs_id: 20, nim: "20201001", tahun_akademik: "2021/2022", semester: "Genap", semester_ke: 4, kode_mk: "TI403", nama_mk: "Rekayasa Perangkat Lunak", sks: 3, nilai: 80, grade: "A", bobot: 4.00 },
    { khs_id: 21, nim: "20201001", tahun_akademik: "2021/2022", semester: "Genap", semester_ke: 4, kode_mk: "TI404", nama_mk: "Kecerdasan Buatan", sks: 3, nilai: 75, grade: "A-", bobot: 3.75 },
    { khs_id: 22, nim: "20201001", tahun_akademik: "2021/2022", semester: "Genap", semester_ke: 4, kode_mk: "TI405", nama_mk: "Keamanan Sistem Informasi", sks: 2, nilai: 78, grade: "A-", bobot: 3.75 },

    // Andi Pratama - Semester 5
    { khs_id: 23, nim: "20201001", tahun_akademik: "2022/2023", semester: "Ganjil", semester_ke: 5, kode_mk: "TI501", nama_mk: "Data Mining", sks: 3, nilai: 82, grade: "A", bobot: 4.00 },
    { khs_id: 24, nim: "20201001", tahun_akademik: "2022/2023", semester: "Ganjil", semester_ke: 5, kode_mk: "TI502", nama_mk: "Cloud Computing", sks: 3, nilai: 76, grade: "A-", bobot: 3.75 },
    { khs_id: 25, nim: "20201001", tahun_akademik: "2022/2023", semester: "Ganjil", semester_ke: 5, kode_mk: "TI503", nama_mk: "Machine Learning", sks: 3, nilai: 85, grade: "A", bobot: 4.00 },
    { khs_id: 26, nim: "20201001", tahun_akademik: "2022/2023", semester: "Ganjil", semester_ke: 5, kode_mk: "TI505", nama_mk: "Manajemen Proyek TI", sks: 2, nilai: 80, grade: "A", bobot: 4.00 },

    // Andi Pratama - Semester 6
    { khs_id: 27, nim: "20201001", tahun_akademik: "2022/2023", semester: "Genap", semester_ke: 6, kode_mk: "TI601", nama_mk: "Pengolahan Citra Digital", sks: 3, nilai: 78, grade: "A-", bobot: 3.75 },
    { khs_id: 28, nim: "20201001", tahun_akademik: "2022/2023", semester: "Genap", semester_ke: 6, kode_mk: "TI602", nama_mk: "Big Data Analytics", sks: 3, nilai: 82, grade: "A", bobot: 4.00 },
    { khs_id: 29, nim: "20201001", tahun_akademik: "2022/2023", semester: "Genap", semester_ke: 6, kode_mk: "TI604", nama_mk: "Kerja Praktek", sks: 2, nilai: 85, grade: "A", bobot: 4.00 },
    { khs_id: 30, nim: "20201001", tahun_akademik: "2022/2023", semester: "Genap", semester_ke: 6, kode_mk: "UN601", nama_mk: "Kewirausahaan", sks: 2, nilai: 80, grade: "A", bobot: 4.00 },

    // Bella Safitri - Sample semester 1-6
    { khs_id: 31, nim: "20201002", tahun_akademik: "2020/2021", semester: "Ganjil", semester_ke: 1, kode_mk: "TI101", nama_mk: "Algoritma dan Pemrograman", sks: 3, nilai: 92, grade: "A", bobot: 4.00 },
    { khs_id: 32, nim: "20201002", tahun_akademik: "2020/2021", semester: "Ganjil", semester_ke: 1, kode_mk: "TI102", nama_mk: "Matematika Diskrit", sks: 3, nilai: 88, grade: "A", bobot: 4.00 },
    { khs_id: 33, nim: "20201002", tahun_akademik: "2020/2021", semester: "Ganjil", semester_ke: 1, kode_mk: "TI103", nama_mk: "Pengantar Teknologi Informasi", sks: 2, nilai: 90, grade: "A", bobot: 4.00 }
];

// Rekap IP per semester
export const dataRekapIP = [
    { nim: "20201001", nama: "Andi Pratama", semester_ke: 1, sks: 14, total_bobot: 54.50, ip: 3.89 },
    { nim: "20201001", nama: "Andi Pratama", semester_ke: 2, sks: 16, total_bobot: 59.00, ip: 3.69 },
    { nim: "20201001", nama: "Andi Pratama", semester_ke: 3, sks: 14, total_bobot: 53.75, ip: 3.84 },
    { nim: "20201001", nama: "Andi Pratama", semester_ke: 4, sks: 14, total_bobot: 54.50, ip: 3.89 },
    { nim: "20201001", nama: "Andi Pratama", semester_ke: 5, sks: 11, total_bobot: 43.00, ip: 3.91 },
    { nim: "20201001", nama: "Andi Pratama", semester_ke: 6, sks: 10, total_bobot: 38.75, ip: 3.88 },
    { nim: "20201002", nama: "Bella Safitri", semester_ke: 1, sks: 14, total_bobot: 56.00, ip: 4.00 },
    { nim: "20201002", nama: "Bella Safitri", semester_ke: 2, sks: 16, total_bobot: 62.00, ip: 3.88 }
];

// Get KRS by NIM
export const getKRSByNIM = (nim) => {
    return dataKRS.filter(k => k.nim === nim);
};

// Get KHS by NIM
export const getKHSByNIM = (nim) => {
    return dataKHS.filter(k => k.nim === nim);
};

// Get KHS by semester
export const getKHSBySemester = (nim, semester_ke) => {
    return dataKHS.filter(k => k.nim === nim && k.semester_ke === semester_ke);
};

// Calculate IPK
export const calculateIPK = (nim) => {
    const khs = dataKHS.filter(k => k.nim === nim);
    if (khs.length === 0) return 0;

    let totalSKS = 0;
    let totalBobot = 0;

    khs.forEach(k => {
        totalSKS += k.sks;
        totalBobot += (k.sks * k.bobot);
    });

    return (totalBobot / totalSKS).toFixed(2);
};

export default { dataKRS, dataKHS, dataRekapIP };
